import React from 'react';

// IMPORT STYLES
import './Header.css';

// IMPORT COMPONENTS
import PersonCard from '../PersonCard/PersonCard'
import Logo from '../Logo/Logo';
import Tags from '../Tags/Tags';


function Header() {

  return(
    <header className='header'>

      <PersonCard />

      <div className='header__decor'>
        <Tags />
        <Logo className='header__logo' />
      </div>
    </header>
  );
}
export default Header;
